module.exports = __webpack_public_path__ + "static/media/fruits_9.d37ba22e.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_9.csv
// module id = 725
// module chunks = 0